import { memo, useMemo } from "react";
import Image from "next/image";

import Box from "@mui/material/Box";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";

import SmallTitle from "./mini-components/SmallTitle";
import { useI18n } from "@/i18n/I18nProvider";

const SECTION_SX = {};

const TITLE_WRAPPER_SX = {
  display: "flex",
  justifyContent: "center",
  mb: 8,
};

const SWIPER_WRAPPER_SX = {
  cursor: "grab",

  "& .swiper-pagination": {
    bottom: "22px !important",
  },

  "& .swiper-pagination-bullet": {
    bgcolor: "#000",
  },

  "& .swiper-button-next, & .swiper-button-prev": {
    zIndex: 100,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundPosition: "center",
    width: "40px !important",
    height: "40px !important",
  },

  "& .swiper-button-next::after, & .swiper-button-prev::after": {
    display: "none",
  },
};

const SLIDE_IMAGE_WRAPPER_SX = {
  position: "relative",
  width: "100%",
  height: "120px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const SWIPER_MODULES = [Pagination, Navigation, Autoplay];

const SWIPER_BREAKPOINTS = {
  0: {
    slidesPerView: 1,
  },
  650: {
    slidesPerView: 2,
  },
  920: {
    slidesPerView: 3,
  },
  1200: {
    slidesPerView: 4,
  },
  1600: {
    slidesPerView: 5.5,
  },
};

function OurPartners({ h3 }) {
  const { t, locale } = useI18n();

  const sponsors = useMemo(() => {
    return t?.business?.sponsors || [];
  }, [t]);

  const titleComponent = h3 || "h2";

  if (!sponsors.length) {
    return null;
  }

  return (
    <Box component="section" className="vertical-safe-padding" sx={SECTION_SX}>
      <Box className="horizontal-safe-padding" sx={TITLE_WRAPPER_SX}>
        <SmallTitle h2={titleComponent} title={t.business.sponsor_title} />
      </Box>

      <Box sx={SWIPER_WRAPPER_SX}>
        <Swiper
          key={locale}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          style={{ paddingBottom: "80px" }}
          pagination={{
            clickable: true,
          }}
          navigation
          slidesPerView={1}
          spaceBetween={10}
          modules={SWIPER_MODULES}
          className="mySwiper"
          breakpoints={SWIPER_BREAKPOINTS}
        >
          {sponsors.map((img, index) => (
            <SwiperSlide key={`${img}-${index}`}>
              <Box sx={SLIDE_IMAGE_WRAPPER_SX}>
                <Image
                  src={img}
                  alt={`Partner logo ${index + 1}`}
                  width={280}
                  height={120}
                  sizes="280px"
                  quality={75}
                  loading="lazy"
                  style={{
                    display: "block",
                    width: "280px",
                    height: "120px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
}

export default memo(OurPartners);
